import { GradientBackgroundProps } from './Layout.types'
import tw, { styled } from 'twin.macro'

export const GradientBackground = styled.div<GradientBackgroundProps>`
    ${tw`absolute`}

    ${({ theme, themeValue }) => {
        const gradientThemes = ['template_default', 'template_lightBlue', 'template_red']

        if (gradientThemes.includes(themeValue)) {
            return `
                background: radial-gradient(circle at 69% 11%, ${theme.colors.secondaryBlue[100]} 0%, 
                    ${theme.colors.basic.white}
                    74%);
                filter: blur(20.875rem);
                border-radius: 0 0 0 15rem;
                height: 82.063rem;
                width: 100%;
                z-index: -1;
            `
        } else if (themeValue === 'template_dark') {
            return `
            background: ${theme.colors.main.bgMain};
            background-image: radial-gradient(circle at 59% 31%, rgba(107, 135, 153, 0.4) 40%, transparent 64%);
            background-repeat: no-repeat;
            background-size: 100% 132rem;
            height: 100%;
            width: 100%;
            z-index: -1;
            `
        } else {
            return `
                background: ${theme.colors.main.bgMain};
                width: 100%;
                height: 100%;
                z-index: -1;
            `
        }
    }}
`

export const LayoutTitleStatusRoot = styled.div`
    ${tw`inline-flex flex-col justify-center lg:justify-start flex-wrap gap-3.5`}
`

export const LayoutTitleStatusImageTitleContainer = styled.div`
    ${tw`flex flex-row flex-wrap lg:flex-nowrap items-center justify-center gap-3.5`}
`
